/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, none, optimisticLockingOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CommunicationAttachmentDto } from '../../communications';
import { JobEDocLogDto, JobEDocOwnerSetDto, JobEDocSigningRequestDto } from './job-e-docs.dto';
import { JobEDocLogMapper, JobEDocOwnerSetMapper, JobEDocSigningRequestMapper } from './job-e-docs.mapper';

@Injectable()
export class JobEDocRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  getOwners(jobId: ID): Observable<JobEDocOwnerSetDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/edocs/owners`, optimisticLockingOf(JobEDocOwnerSetMapper));
  }

  updateOwnerSet(jobId: ID, ownerSet: JobEDocOwnerSetDto): Observable<JobEDocOwnerSetDto> {
    return this.httpPut(`${this.bp}/jobs/${jobId}/edocs/owners`, ownerSet, optimisticLockingOf(JobEDocOwnerSetMapper));
  }

  getLog(jobId: ID): Observable<JobEDocLogDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/edocs/log`, JobEDocLogMapper);
  }

  sendToSign(jobId: ID, signing: JobEDocSigningRequestDto): Observable<void> {
    return this.httpPut(`${this.bp}/jobs/${jobId}/edocs/send-to-sign`, signing, JobEDocSigningRequestMapper, none());
  }

  getLinks(jobId: ID, documentId: ID): Observable<CommunicationAttachmentDto[]> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/edocs/log/${documentId}/gdrive-links`, identity());
  }
}
